import { render, staticRenderFns } from "./postdoctorSocial.vue?vue&type=template&id=4766fe7e&scoped=true&"
import script from "./postdoctorSocial.vue?vue&type=script&lang=js&"
export * from "./postdoctorSocial.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorSocial.vue?vue&type=style&index=0&id=4766fe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4766fe7e",
  null
  
)

export default component.exports